export interface Episode {
  id: number;
  number: number;
  title: string;
  cover: string;
  airDate: string;
  duration: string;
  synopsis: string;
  highlight: string;
  cast: string[];
}

export const episodes: Episode[] = [
  {
    id: 1,
    number: 1,
    title: "月下之门",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20night%20scene%20of%20an%20ancient%20japanese%20wooden%20mansion%20gate%20under%20a%20pale%20full%20moon%2C%20misty%20air%2C%20dramatic%20moonlight%20with%20subtle%20gold%20accents%2C%20mysterious%20moody%20film%20still%2C%20muted%20cold%20tones%2C%20highly%20detailed%20cinematic%20composition&width=600&height=900&seq=wuyan-ep-01-cover&orientation=portrait",
    airDate: "2026-08-01",
    duration: "45分钟",
    synopsis: "留学归来的插画师沈月为了整理祖母遗物，独自回到被荒废多年的山中别院。当夜满月升起，她在尘封的纸门后听见了不属于这个时代的脚步，一段被刻意遗忘的往事就此苏醒。",
    highlight: "开篇悬念",
    cast: ["林知夏", "顾承砚", "苏晚宁"],
  },
  {
    id: 2,
    number: 2,
    title: "无颜之序",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20interior%20of%20an%20old%20japanese%20room%20with%20a%20faded%20paper%20scroll%20and%20a%20single%20oil%20lamp%2C%20faint%20gold%20glow%20in%20darkness%2C%20mysterious%20atmosphere%2C%20moody%20film%20still%2C%20cold%20muted%20tones%2C%20highly%20detailed%20cinematic%20lighting&width=600&height=900&seq=wuyan-ep-02-cover&orientation=portrait",
    airDate: "2026-08-08",
    duration: "44分钟",
    synopsis: "沈月在一本泛黄的手札中发现祖母年轻时的名字被人为涂去。她循着纸页上的线索走进别院深处，遇见一位自称看守旧宅、却记不清自己来历的年轻男子。",
    highlight: "线索初现",
    cast: ["林知夏", "顾承砚"],
  },
  {
    id: 3,
    number: 3,
    title: "镜中旧影",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20scene%20of%20an%20antique%20cracked%20mirror%20in%20a%20dim%20room%20reflecting%20a%20blurred%20figure%2C%20cold%20moonlight%20through%20a%20window%2C%20hint%20of%20gold%20trim%20on%20the%20frame%2C%20eerie%20mysterious%20film%20still%2C%20muted%20desaturated%20tones%2C%20cinematic%20detail&width=600&height=900&seq=wuyan-ep-03-cover&orientation=portrait",
    airDate: "2026-08-15",
    duration: "46分钟",
    synopsis: "一夜之间，别院里所有镜面都映出同一个女人的侧影。沈月试图用相机记录，照片却只留下一片空白。她开始怀疑，真正被“抹去”的或许不只是名字。",
    highlight: "恐怖氛围",
    cast: ["林知夏", "顾承砚", "周砚白"],
  },
  {
    id: 4,
    number: 4,
    title: "纸上月色",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20scene%20of%20scattered%20old%20handwritten%20letters%20on%20a%20wooden%20desk%20lit%20by%20a%20small%20lamp%2C%20faint%20gold%20warmth%20against%20deep%20blue%20shadows%2C%20mysterious%20quiet%20mood%2C%20moody%20film%20still%2C%20muted%20cold%20tones%2C%20detailed%20cinematic%20composition&width=600&height=900&seq=wuyan-ep-04-cover&orientation=portrait",
    airDate: "2026-08-22",
    duration: "43分钟",
    synopsis: "手札后半部藏着一段未寄出的书信。信中提到的“约定之日”正是本月的满月之夜，也是沈月与那个神秘看守第一次真正交谈的日子。",
    highlight: "情感转折",
    cast: ["林知夏", "顾承砚"],
  },
  {
    id: 5,
    number: 5,
    title: "守夜人",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20silhouette%20of%20a%20lone%20man%20standing%20in%20a%20courtyard%20at%20night%20holding%20a%20lantern%2C%20deep%20shadows%2C%20single%20warm%20gold%20light%20source%2C%20dramatic%20mysterious%20atmosphere%2C%20moody%20film%20still%2C%20muted%20cold%20tones%2C%20cinematic%20lighting&width=600&height=900&seq=wuyan-ep-05-cover&orientation=portrait",
    airDate: "2026-08-29",
    duration: "45分钟",
    synopsis: "看守人的身份逐渐浮出水面：他似乎与这座别院共同度过了比沈月想象中更漫长的岁月。而他手中那盏灯，只为等待一个人归来。",
    highlight: "关键揭示",
    cast: ["林知夏", "顾承砚", "苏晚宁"],
  },
  {
    id: 6,
    number: 6,
    title: "沉入深蓝",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20underwater%20abstract%20scene%20of%20sinking%20white%20fabric%20and%20rippling%20light%20from%20above%2C%20deep%20cold%20blue%20gradient%2C%20faint%20gold%20shimmer%20particles%2C%20dreamlike%20mysterious%20film%20still%2C%20muted%20tones%2C%20highly%20detailed&width=600&height=900&seq=wuyan-ep-06-cover&orientation=portrait",
    airDate: "2026-09-05",
    duration: "47分钟",
    synopsis: "一段记忆如潮水般涌入沈月的梦境。她看见祖母年轻时的模样，也看见那场大火之中，有人为了守住一个秘密，选择从此不再拥有面容。",
    highlight: "全剧高潮前奏",
    cast: ["林知夏", "顾承砚", "周砚白", "苏晚宁"],
  },
  {
    id: 7,
    number: 7,
    title: "面纱之下",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20scene%20of%20a%20faint%20translucent%20veil%20drifting%20in%20a%20dark%20room%20with%20moonlight%20behind%2C%20soft%20gold%20edge%20glow%2C%20ethereal%20mysterious%20atmosphere%2C%20moody%20film%20still%2C%20muted%20cold%20tones%2C%20elegant%20cinematic%20composition&width=600&height=900&seq=wuyan-ep-07-cover&orientation=portrait",
    airDate: "2026-09-12",
    duration: "45分钟",
    synopsis: "真相像一层薄纱，越接近越模糊。沈月终于明白，祖母留下的不只是别院，更是一个必须由她亲手做出的选择——记住，还是放手。",
    highlight: "情绪爆发",
    cast: ["林知夏", "顾承砚"],
  },
  {
    id: 8,
    number: 8,
    title: "满月之约",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20wide%20shot%20of%20a%20large%20pale%20full%20moon%20above%20a%20dark%20mountain%20estate%20rooftop%2C%20deep%20blue%20night%20sky%2C%20subtle%20gold%20cloud%20rim%20light%2C%20dramatic%20epic%20mood%2C%20moody%20film%20still%2C%20muted%20cold%20tones%2C%20cinematic%20detail&width=600&height=900&seq=wuyan-ep-08-cover&orientation=portrait",
    airDate: "2026-09-19",
    duration: "46分钟",
    synopsis: "满月之夜，别院重新点亮了所有的灯。沈月与看守人并肩站在庭中，等待那个跨越数十年的约定，在属于他们的这一夜兑现。",
    highlight: "唯美名场面",
    cast: ["林知夏", "顾承砚", "苏晚宁"],
  },
  {
    id: 9,
    number: 9,
    title: "焚信",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20scene%20of%20burning%20paper%20letters%20with%20glowing%20embers%20and%20smoke%20in%20a%20dark%20courtyard%2C%20warm%20orange%20fire%20light%20against%20cold%20blue%20shadows%2C%20dramatic%20mysterious%20film%20still%2C%20muted%20tones%2C%20cinematic%20composition&width=600&height=900&seq=wuyan-ep-09-cover&orientation=portrait",
    airDate: "2026-09-26",
    duration: "44分钟",
    synopsis: "为了不让往事再伤害任何人，沈月亲手烧掉了一部分手札。火焰映亮她与看守人的脸，也照出了两人各自不愿说出口的心事。",
    highlight: "抉择时刻",
    cast: ["林知夏", "顾承砚"],
  },
  {
    id: 10,
    number: 10,
    title: "旧宅新生",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20scene%20of%20an%20old%20wooden%20mansion%20with%20newly%20lit%20paper%20lanterns%20along%20a%20stone%20path%2C%20warm%20gold%20glow%20against%20deep%20blue%20night%2C%20hopeful%20quiet%20atmosphere%2C%20moody%20film%20still%2C%20muted%20tones%2C%20detailed%20cinematic%20lighting&width=600&height=900&seq=wuyan-ep-10-cover&orientation=portrait",
    airDate: "2026-10-03",
    duration: "43分钟",
    synopsis: "沈月决定把别院改造成一间小小的插画工作室。她开始在这里画画、待客，也第一次允许自己相信——有些离别，是为了更好的重逢。",
    highlight: "温柔治愈",
    cast: ["林知夏", "苏晚宁", "周砚白"],
  },
  {
    id: 11,
    number: 11,
    title: "月落无声",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20scene%20of%20a%20setting%20moon%20low%20over%20dark%20misty%20mountains%20behind%20an%20old%20estate%2C%20deep%20cold%20blue%20sky%20with%20faint%20gold%20horizon%20glow%2C%20melancholic%20mysterious%20mood%2C%20moody%20film%20still%2C%20muted%20tones%2C%20cinematic%20composition&width=600&height=900&seq=wuyan-ep-11-cover&orientation=portrait",
    airDate: "2026-10-10",
    duration: "45分钟",
    synopsis: "看守人告诉沈月，他的时间快要走到尽头。月落之时，他将随最后一片月光一同消散，除非有人愿意将一个名字重新还给这座老宅。",
    highlight: "离别前夜",
    cast: ["林知夏", "顾承砚"],
  },
  {
    id: 12,
    number: 12,
    title: "还给你的名字",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20dawn%20scene%20over%20an%20old%20estate%20courtyard%20with%20first%20warm%20light%20breaking%20through%20cold%20blue%20night%20mist%2C%20soft%20gold%20sunrise%20glow%2C%20hopeful%20emotional%20finale%20mood%2C%20moody%20film%20still%2C%20muted%20tones%2C%20cinematic%20detail&width=600&height=900&seq=wuyan-ep-12-cover&orientation=portrait",
    airDate: "2026-10-17",
    duration: "52分钟",
    synopsis: "大结局。沈月在自己的画展开幕之夜，于最醒目的一幅画下写上了那个被抹去多年的名字。当晨光洒进别院，一切终于有了归宿。",
    highlight: "大结局",
    cast: ["林知夏", "顾承砚", "苏晚宁", "周砚白"],
  },
];